import { createAggregatedProgress } from "@/libs/progress"
import type { PerformanceEntry } from "@/libs/telemetry/performance"
import { Graph } from "../../framework"
import {
  type CreateOptions as IlluminationCreateOptions,
  type Illumination as IlluminationDetection,
  create as createIlluminationEstimation,
} from "../../modules/illumination/illumination"
import { type FaceDetection, type FramePixels } from "../../modules/types.d"

export type { IlluminationDetection }

export type CreateOptions = {
  performance?: { child: () => PerformanceEntry }
  initialState?: IlluminationCreateOptions["initialState"]
  onProgress?: (progress: number) => void
}

export const create = async (opts?: CreateOptions) => {
  const onProgress = opts?.onProgress
    ? createAggregatedProgress({
        // 80% for illumination initialization
        // 20% for the rest
        coeffs: [0.8, 0.2],
        onProgress: opts?.onProgress,
      })
    : undefined

  const graph = new Graph<[FramePixels, FaceDetection], [IlluminationDetection]>()
  const illuminationEstimation = await createIlluminationEstimation(graph, {
    performance: opts?.performance?.child(),
    initialState: opts?.initialState,
    onProgress: onProgress?.bind(null, 0),
  })

  onProgress?.(1, 1)

  graph.in(0).connect(illuminationEstimation.in(0))
  graph.in(1).connect(illuminationEstimation.in(1))
  illuminationEstimation.out(0).connect(graph.out(0))

  return graph
}
